import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Scissors } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, fmtMoney } from "@/lib/api";
import { Spinner, Tag } from "@/components/common";

const TONE = { weak: "red", collecting: "slate", performing: "emerald" };

export const TrimBlocks = () => {
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/reports/trim-hours").then((r) => setD(r.data)).catch(() => setD(null));
  useEffect(() => { load(); }, []);
  const check = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/reports/trim-hours/check");
      if (data.created) toast.success("Trim weak hours proposal added to Approvals: dry run, then approve"); else toast.info(data.note, { duration: 6000 });
      load();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  if (!d) return null;
  return (
    <div className="mt-5 border-t border-[#1e293b] pt-4" data-testid="trim-blocks">
      <div className="mb-2 flex flex-wrap items-center gap-3">
        <div className="cc-eyebrow">Extra-hours blocks</div>
        <span className="text-xs text-slate-500" data-testid="trim-status-note">{d.note || `Schedule live ${d.days_live} days · clinic-hours cost per lead ${fmtMoney(d.clinic_cost_per_lead)}`}</span>
        <button data-testid="trim-check-btn" onClick={check} disabled={busy} className="cc-btn cc-btn-ghost ml-auto px-3 py-1 text-xs">{busy ? <Spinner className="h-3.5 w-3.5" /> : <Scissors className="h-3.5 w-3.5" />} Check weak hours now</button>
      </div>
      {d.open_proposal_id && <div className="mb-2 text-xs text-amber-300" data-testid="trim-open-proposal">A Trim weak hours proposal is waiting. <Link to="/approvals" className="underline">Open Approvals</Link></div>}
      {d.blocks.length > 0 && (
        <table className="w-full text-left text-xs" data-testid="trim-blocks-table">
          <thead className="text-slate-500"><tr>{["Block", "Spend", "Clicks", "Leads", "Status"].map((h) => <th key={h} className="py-1 font-medium">{h}</th>)}</tr></thead>
          <tbody>{d.blocks.map((b) => (
            <tr key={b.id} className="border-t border-[#1e293b] text-slate-300" data-testid={`trim-block-${b.id}`}>
              <td className="py-1.5 text-slate-100">{b.name}</td><td className="py-1.5 font-mono">{fmtMoney(b.spend)}</td><td className="py-1.5 font-mono">{b.clicks}</td><td className="py-1.5 font-mono">{b.leads}</td>
              <td className="py-1.5"><Tag tone={TONE[b.verdict]}>{d.ready || b.verdict !== "weak" ? b.status : `Weak (waiting for ${d.settings.wait_days} days of data)`}</Tag>{b.verdict === "weak" && <div className="mt-0.5 text-[10px] text-slate-500">{b.reason}</div>}</td>
            </tr>
          ))}</tbody>
        </table>
      )}
    </div>
  );
};
